<template>
  <div class="page-container md-layout-row">
    <md-app v-if="loaded">
      <md-app-drawer md-permanent="card">
        <filters
          :names="artistNames"
          :cities="cities"
          :mediums="mediums"
          :regions="regions"
          @selectedName="selectedName"
          @selectedCity="selectedCity"
          @selectedMediums="selectedMediums"
          @selectedRegion="selectedRegion"
        />
      </md-app-drawer>
      <md-app-content>
        <right-detail ref="rightDetail" v-if="selectedArtist"  :selectedArtist="selectedArtist" @close="closeDetailPanel"/>
        <city-panel v-if="cityPanel" :city="city" @artistSelected="artistSelected" @close="closeCityPanel"/>
        <Map ref="mapboxMap" :geoJSON="geoJSON" :filter="filter" @featureListed="featureListed" @clickedCity="clickedCity"
        />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import { getcsvdata, aggregateByLocation, toGeoJSON } from '@/data-loader'
import Filters from '../components/Filters'
import Map from '../components/Map'
import RightDetail from '../components/RightDetail'
import regions from '../regions.json'
import _ from 'lodash'
import CityPanel from '../components/CityPanel'
export default {
  name: 'home',
  components: {
    Filters,
    Map,
    RightDetail,
    CityPanel
  },
  data () {
    return {
      loaded: false,
      artists: null,
      locations: null,
      geoJSON: null,
      selectedArtist: null,
      features: [],
      filter: null,
      regions: [],
      city: null,
      cityPanel: false,
      filteredArtists: []
    }
  },
  async mounted () {
    const url = process.env.BASE_URL + 'data.csv'
    this.artists = await getcsvdata(url)
    this.locations = aggregateByLocation(this.artists)
    this.geoJSON = toGeoJSON(this.locations, {
      Point: ['Latitude', 'Longitude']
    })
    this.loaded = true
    this.regions = [...new Set(regions.features.map((f) => f.properties.name))]
  },
  methods: {
    featureListed (features) {
      if (features) {
        this.selectedArtist = null
        this.features = []
        features.forEach(feature => {
          feature.properties.items = JSON.parse(feature.properties.items)
          this.features.push(feature.properties)
        })
      } else {
        this.closeDetailPanel()
      }
    },
    closeDetailPanel () {
      this.selectedArtist = null
      if (this.city) {
        this.clickedCity(this.city.location)
      }
    },
    artistSelected (item) {
      this.selectedArtist = item
      this.cityPanel = false
    },
    selectedName (selectedName) {
      const artist = this.artists.filter(obj => { return obj.Name === selectedName })
      this.selectedArtist = artist[0]
      this.cityPanel = false
      this.city = this.locations.filter(obj => { return obj.location === this.selectedArtist['Currently based in'] })[0]
      this.$refs.mapboxMap.selectCity(this.selectedArtist['Currently based in'])
      this.features = this.locations.filter(obj => { return obj.location === this.selectedArtist['Currently based in'] })
      this.$refs.mapboxMap.map.flyTo({ center: [artist[0].Longitude, artist[0].Latitude], zoom: 7, offset: [-this.offset, 0] })
    },
    selectedCity (selectedCity) {
      const location = this.locations.filter(obj => { return obj.location === selectedCity })
      this.city = location[0]
      this.cityPanel = true
      this.$refs.mapboxMap.selectCity(location[0].location)
      this.selectedArtist = null
      this.$refs.mapboxMap.map.flyTo({ center: [location[0].Longitude, location[0].Latitude], zoom: 7, offset: [-this.offset, 0] })
    },
    selectedMediums (selectedMediums) {
      const artists = this.artists.filter(obj => { return selectedMediums.includes(obj['Medium 1']) })
      artists.push(...this.artists.filter(obj => { return selectedMediums.includes(obj['Medium 2']) }))
      const locations = [...new Set(artists.map(obj => obj['Currently based in']))]
      if (locations.length !== 0) {
        this.filteredArtists = artists
        this.filter = [
          'match',
          ['get', 'location'],
          locations,
          true,
          false
        ]
      } else {
        this.filter = null
        this.filteredArtists = []
      }
      if (this.cityPanel) {
        this.clickedCity(this.city.location)
      }
    },
    selectedRegion (selectedRegion) {
      let coordinates
      const feature = regions.features.filter(obj => { return obj.properties.name === selectedRegion })
      if (feature.length === 2) {
        coordinates = feature[0].geometry.coordinates
        coordinates.push(...feature[1].geometry.coordinates)
        coordinates = [[].concat(...coordinates)]
      } else {
        coordinates = feature[0].geometry.coordinates
      }

      const maxLat = _.max(coordinates[0].map((o) => { return o[1] }))
      const maxLong = _.maxBy(coordinates[0].map((o) => { return o[0] }))
      const minLat = _.minBy(coordinates[0].map((o) => { return o[1] }))
      const minLong = _.minBy(coordinates[0].map((o) => { return o[0] }))
      this.$refs.mapboxMap.map.fitBounds([
        [maxLong, minLat],
        [minLong, maxLat]
      ], { padding: { top: 50, bottom: 50, left: 250, right: 250 }, offset: [-this.offset / 2, 0] })
    },
    clickedCity (clickedCity) {
      if (clickedCity) {
        const location = this.locations.filter(obj => { return obj.location === clickedCity })
        if (this.filteredArtists.length !== 0) {
          const artists = location[0].items.filter(obj => { return this.filteredArtists.includes(obj) })
          const filteredLocation = _.cloneDeep(location)
          filteredLocation[0].items = artists
          this.city = filteredLocation[0]
        } else {
          this.city = location[0]
        }
        this.cityPanel = true
        this.selectedArtist = null
      } else {
        this.closeCityPanel()
      }
    },
    closeCityPanel () {
      this.cityPanel = false
      this.city = null
      this.$refs.mapboxMap.unselectCity()
    }
  },
  computed: {
    artistNames: function () {
      return this.artists.map(a => a.Name)
    },
    cities: function () {
      return this.locations.map(l => l.location)
    },
    mediums: function () {
      const mediums = this.artists.map(a => a['Medium 1'])
      mediums.push(...this.artists.map(a => a['Medium 2']))
      return [...new Set(mediums.filter((m) => { return m !== '' }))]
    },
    offset: function () {
      return 360 / 2
    }
  }
}
</script>

<style lang="scss" scoped>
.md-app {
  position: absolute;
  min-height: 350px;
  border: 1px solid rgba(#000, 0.12);
  width: 100vw;
  .md-drawer {
    width: 320px;
  }
  .md-app-content {
    padding: 0;
  }
}
</style>
